import { hasKey } from "../../exports/helpers.js";
export default function addKey(data, key, itemGenerator) {
    hasKey(data, key, true);
    for (let i = 0; i < data.length; i++) {
        data[i][key] = itemGenerator(data[i]);
    }
    return data;
}
//# sourceMappingURL=addKey.js.map